import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

function Regulamin({ onLogout, userRole }) {
	const [documents, setDocuments] = useState([]);
	const [status, setStatus] = useState({ type: "", message: "" });

	const formatDocTitle = (value) => {
		if (!value) {
			return "Regulamin";
		}
		if (value === "content") {
			return "Regulamin";
		}
		const spaced = value.replace(/[_-]+/g, " ").trim();
		return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : "Regulamin";
	};

	const formatFieldLabel = (key) => {
		const match = String(key).match(/section(\d+)/i);
		if (match) {
			return `Sekcja ${match[1]}`;
		}
		const spaced = String(key).replace(/[_-]+/g, " ").trim();
		if (!spaced) {
			return "Tresc";
		}
		return spaced.charAt(0).toUpperCase() + spaced.slice(1);
	};

	useEffect(() => {
		const unsubscribe = onSnapshot(
			collection(db, "regulamin"),
			(snapshot) => {
				const items = snapshot.docs.map((docSnap) => ({
					id: docSnap.id,
					...docSnap.data()
				}));
				setDocuments(items);
			},
			(error) => {
				setStatus({
					type: "error",
					message: error.message || "Nie udalo sie wczytac regulaminu."
				});
			}
		);

		return () => unsubscribe();
	}, []);

	const sectionsByDoc = useMemo(
		() =>
			documents.map((item) => {
				const fields = Object.entries(item)
					.filter(
						([key, value]) =>
							key !== "id" && typeof value === "string" && value.trim() !== ""
					)
					.sort(([left], [right]) => {
						const leftMatch = left.match(/section(\d+)/i);
						const rightMatch = right.match(/section(\d+)/i);
						if (leftMatch && rightMatch) {
							return Number(leftMatch[1]) - Number(rightMatch[1]);
						}
						if (leftMatch) {
							return -1;
						}
						if (rightMatch) {
							return 1;
						}
						return left.localeCompare(right);
					});

				return { id: item.id, fields };
			}),
		[documents]
	);

	const hasContent = sectionsByDoc.some((doc) => doc.fields.length > 0);

	return (
		<main className="ClientShell">
			<div className="ClientNavWrap">
				<Navbar
					menuItems={menuItems}
					onLogout={onLogout}
					userRole={userRole}
				/>
			</div>

			<section className="ClientHero">
				<div className="WelcomePanel">
					<p className="Badge">Regulamin</p>
					<h1 className="Title">Regulamin schroniska</h1>
					<p className="Subtitle">Wszystkie sekcje regulaminu z bazy.</p>

					{status.message ? (
						<p className={status.type === "error" ? "Error" : "Success"}>
							{status.message}
						</p>
					) : null}

					{!hasContent ? (
						<p className="Muted">Brak danych regulaminu.</p>
					) : null}
				</div>

				{sectionsByDoc.map((doc) => (
					<div className="WelcomePanel" key={doc.id}>
						<p className="Badge">{formatDocTitle(doc.id)}</p>
						{doc.fields.length === 0 ? (
							<p className="Muted">Brak danych w tej sekcji.</p>
						) : (
							doc.fields.map(([key, value]) => (
								<div className="Field" key={`${doc.id}-${key}`}>
									<span className="Label">{formatFieldLabel(key)}</span>
									<p className="Subtitle" style={{ whiteSpace: "pre-wrap" }}>
										{value}
									</p>
								</div>
							))
						)}
					</div>
				))}
			</section>
		</main>
	);
}

export default Regulamin;
